import SubscribeForm from "../../global/components/SubscribeForm";
import { Route, Routes } from "react-router-dom";

import MainPage from "./MainPage";
import BlogPostPage from "./BlogPostPage";

export default function Blog() {
  return (
    <div className="flex flex-col justify-center items-center">
      <Routes>
        <Route path="/" element={<MainPage />} />
        <Route path="/:id/:slug" element={<BlogPostPage />} />
      </Routes>
      <SubscribeForm />
    </div>
  )
}
